// Professional notice: once on the first visit, remembered for 365 days.
document.addEventListener('DOMContentLoaded', () => {
  const popin = document.querySelector('.js-popin');
  const confirm = popin?.querySelector('.js-popin-close');
  if (!popin || !confirm) return;

  let acknowledged = false;
  let scheduled = false;
  let previousFocus;
  const hasAcknowledged = () => {
    if (acknowledged) return true;
    try { return /(?:^|;\s*)SYM_POPIN=1(?:;|$)/.test(document.cookie); }
    catch (_) { return false; }
  };

  if (!hasAcknowledged()) {
    scheduled = true;
    // Allow section replacement / quick-add closing to finish before taking focus.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      scheduled = false;
      if (hasAcknowledged() || popin.open) return;
      previousFocus = document.activeElement;
      if (typeof popin.showModal === 'function') popin.showModal();
      else popin.setAttribute('open', '');
      popin.classList.add('--opened');
      document.body.classList.add('ux-pro-notice-open');
      confirm.focus({ preventScroll: true });
    }));
  }

  // Escape must not silently count as a professional confirmation.
  popin.addEventListener('cancel', event => event.preventDefault());
  popin.addEventListener('keyup', event => event.stopPropagation());
  confirm.addEventListener('click', () => {
    acknowledged = true;
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    try { document.cookie = `SYM_POPIN=1;expires=${expires};path=/;SameSite=Lax`; }
    catch (_) { /* Keep this page usable when the browser blocks cookies. */ }
    popin.classList.remove('--opened');
    if (typeof popin.close === 'function') popin.close();
    else popin.removeAttribute('open');
    document.body.classList.remove('ux-pro-notice-open');
    const drawer = document.querySelector('cart-drawer.active .drawer__inner');
    if (drawer && typeof trapFocus === 'function') trapFocus(drawer, drawer);
    else if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
});

